import React, { useState, useEffect, useRef, useContext } from 'react';
import Head from 'next/head';
import TreeD from '../components/section3D/TreeD';

import NavTreed from '../components/section3D/NavTreed';

function interactive() {
 return (
  <div className=' h-screen min-h-[500px]'>
   <Head>
    <title>JAMIVIZ - Interactive</title>

    <meta property='og:title' content='JAMIVIZ - Interactive' />
   </Head>
   <NavTreed />
   <TreeD />
  </div>
 );
}

export default interactive;
